import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { OrgCategory } from '../models/OrgCategory';

@Injectable()
export class OrgCategoryService {
  constructor(private http: Http) {}

  all(): Observable<any> {
    const url = environment.api.baseUrl + environment.api.orgCategory;
    return this.http.get(url).map(res => {
      return res.json().map(j => new OrgCategory(j));
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/org-category.service.ts